import { Component, Input, OnInit } from '@angular/core';
import {MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { MediaService } from 'src/app/new-media/common/media.service';
import { SiteService } from 'src/app/new-sites-management/common/services/site.service';
// import { ManageMediaComponent } from '../manage-media.component';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css']
})
export class UpdateComponent implements OnInit {
  @Input() data;
  constructor(public mediaManagerService: MediaService,
    public siteService: SiteService,
     private snotifyService: ToastrService,
    private dialogRef: MatDialogRef<any>) { }

  ngOnInit() {
  }
  
  public onFilesAdded(event,cultureId) {
    var formData = new FormData();
    formData.append("CultureId", cultureId.toString());
    formData.append("Id", this.data.id);
    if (this.mediaManagerService.folder.parentId) {
      formData.append("ParentId", this.mediaManagerService.folder.parentId.toString());
    }
    for (var i = 0; i < event.addedFiles.length; i++) {
      formData.append("Uploads", event.addedFiles[i]);
    }
    this.mediaManagerService.saveMedia(formData).subscribe((res: any) => {
      this.openNotifySuccess('Image updated successfuly');
      this.dialogRef.close();
      this.mediaManagerService
        .searchMediaAndFolders(this.mediaManagerService.folder.parentId ? this.mediaManagerService.folder.parentId : 0)
        .subscribe();
    });
  }

  public openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

 
  
  close() {
    this.dialogRef.close();
  }

}
